import {
  GatedCommunityOption,
  BooleanOption,
  HvacRoofAgeTimeOption,
  LockboxLocationOptions,
  AccessOption,
} from 'sellDirect/declarations/InputOptions';

type InputOption<V> = {
  label: string;
  required?: boolean;
  value: V;
};

export const HVAC_AGE_OPTIONS: Array<InputOption<HvacRoofAgeTimeOption>> = [
  { label: '0-7 years', value: '0_to_7_years' },
  { label: '8-15 years', value: '8_to_15_years' },
  { label: '16+ years', value: '16_plus_years' },
  { label: 'Not sure', value: 'not_sure' },
];

export const ROOF_AGE_OPTIONS: Array<InputOption<HvacRoofAgeTimeOption>> = [
  { label: '0-7 years', value: '0_to_7_years' },
  { label: '8-15 years', value: '8_to_15_years' },
  { label: '16+ years', value: '16_plus_years' },
  { label: 'Not sure', value: 'not_sure' },
];

export const YES_NO_OPTIONS: Array<InputOption<BooleanOption>> = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const GATED_COMMUNITY_OPTIONS: Array<InputOption<GatedCommunityOption>> = [
  {
    label: 'Gate code or callbox',
    required: true,
    value: 'gate_code',
  },
  {
    label: 'Guard',
    required: true,
    value: 'guard',
  },
  {
    label: 'Other',
    required: true,
    value: 'other',
  },
];

export const LOCKBOX_LOCATION_OPTIONS: Array<InputOption<LockboxLocationOptions>> = [
  {
    label: 'On the front door handle (Opendoor recommended)',
    value: 'front_door',
  },
  {
    label: 'On the front hose bib',
    value: 'front_hose_bib',
  },
  {
    label: 'Gas line',
    value: 'gas_line',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

/** TODO: Add documentation */
export const getAccessOptions = (): Array<InputOption<AccessOption>> => [
  { label: 'I will be home', value: 'will_be_home' },
  { label: 'I will leave a key', required: true, value: 'will_leave_a_key' },
  { label: 'The home has a lockbox', required: true, value: 'will_leave_in_lockbox' },
  { label: 'The home has a gate code', required: true, value: 'has_a_gate_code' },
  { label: 'The home has a garage door code', required: true, value: 'has_a_garage_door_code' },
];

export const ACCESS_OPTIONS_PLACEHOLDER_MAP = {
  will_leave_a_key: 'Key location',
  will_leave_in_lockbox: 'Lockbox code',
  has_a_gate_code: 'Gate code',
  has_a_garage_door_code: 'Garage door code',
} as { [key: string]: string };
